export default __webpack_public_path__ + "static/3-14ea849005f91fc76b91bcb41f2b9817.png";